export const BG_LINEAR_CLASS =
	"bg-linear-to-tr from-primary/50 via-secondary to-primary";
